/* Modera — Gallery Minimal
   Cart drawer, mobile menu, product gallery, sticky buy bar, sort. */
(function () {
  'use strict';

  var body = document.body;
  var money = window.Modera && window.Modera.moneyFormat ? window.Modera.moneyFormat : 'AED {{amount}}';

  /* ---------------- utils ---------------- */

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace(/\.00$/, '');
    // Insert thousands separators.
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    value = parts.join('.');
    return money.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  function on(selector, event, handler, root) {
    (root || document).addEventListener(event, function (e) {
      if (!e.target || !e.target.closest) return;
      var target = e.target.closest(selector);
      if (target) handler(e, target);
    });
  }

  /* ---------------- drawers ---------------- */

  var lastFocus = null;

  function openDrawer(name) {
    lastFocus = document.activeElement;
    body.setAttribute('data-drawer', name);
    var drawer = document.querySelector('.drawer--' + name);
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    var focusable = drawer.querySelector('button, a, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 120);
  }

  function closeDrawer() {
    var name = body.getAttribute('data-drawer');
    if (name) {
      var drawer = document.querySelector('.drawer--' + name);
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
    }
    body.removeAttribute('data-drawer');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  on('[data-open-cart]', 'click', function (e) {
    e.preventDefault();
    openDrawer('cart');
  });

  on('[data-open-menu]', 'click', function (e) {
    e.preventDefault();
    openDrawer('menu');
  });

  on('[data-close-drawer]', 'click', function (e) {
    e.preventDefault();
    closeDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && body.hasAttribute('data-drawer')) closeDrawer();
  });

  // Trap focus inside an open drawer.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var name = body.getAttribute('data-drawer');
    if (!name) return;
    var drawer = document.querySelector('.drawer--' + name);
    if (!drawer) return;
    var items = drawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea'
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ---------------- cart ---------------- */

  function setBusy(isBusy) {
    var drawer = document.querySelector('.drawer--cart');
    if (drawer) drawer.style.opacity = isBusy ? '0.55' : '';
  }

  function refreshCart(openAfter) {
    return fetch(window.Modera.routes.cart + '?section_id=cart-drawer', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-contents]');
        var current = document.querySelector('[data-cart-contents]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;

        var freshCount = parsed.querySelector('[data-cart-count]');
        var count = freshCount ? parseInt(freshCount.getAttribute('data-cart-count'), 10) : 0;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.setAttribute('data-cart-count', String(count));
          el.textContent = count;
          el.hidden = count === 0;
        });

        if (openAfter && window.Modera.cartDrawer) openDrawer('cart');
        document.dispatchEvent(new CustomEvent('modera:cart-refreshed'));
      })
      .catch(function () {
        window.location.href = window.Modera.routes.cart;
      });
  }

  function addToCart(id, quantity) {
    setBusy(true);
    return fetch(window.Modera.routes.cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        setBusy(false);
        if (!res.ok) {
          alert(res.data.description || res.data.message || 'Could not add this item.');
          return;
        }
        // With the drawer switched off there is nothing to show, so go to the cart.
        if (!window.Modera.cartDrawer) {
          window.location.href = window.Modera.routes.cart;
          return;
        }
        return refreshCart(true);
      })
      .catch(function () {
        setBusy(false);
      });
  }

  function changeLine(key, quantity) {
    setBusy(true);
    return fetch(window.Modera.routes.cartChange, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () {
        setBusy(false);
        // The cart page renders totals server-side, so reload there.
        if (document.body.getAttribute('data-template') === 'cart') {
          window.location.reload();
          return;
        }
        return refreshCart(false);
      })
      .catch(function () {
        setBusy(false);
      });
  }

  // Quick-add buttons on cards and rows.
  on('[data-add-variant]', 'click', function (e, el) {
    e.preventDefault();
    e.stopPropagation();
    addToCart(el.getAttribute('data-add-variant'), 1);
  });

  // Main product form.
  on('[data-product-form]', 'submit', function (e, form) {
    e.preventDefault();
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    if (!id || !id.value) return;
    addToCart(id.value, qty ? parseInt(qty.value, 10) || 1 : 1);
  });

  // Cart line quantity + remove.
  on('[data-line-change]', 'click', function (e, el) {
    e.preventDefault();
    var key = el.getAttribute('data-key');
    var next = parseInt(el.getAttribute('data-line-change'), 10);
    changeLine(key, next);
  });

  on('[data-line-remove]', 'click', function (e, el) {
    e.preventDefault();
    changeLine(el.getAttribute('data-line-remove'), 0);
  });

  /* ---------------- free gift picker ----------------
     Adds the chosen gift variant at quantity 1. If a different gift was
     already in the cart, its line is removed first so only one free gift
     is ever active at a time. Gift lines are tagged via a line item
     property so this script can find them again after a refresh. */

  var GIFT_PROPERTY = '_free_gift';

  function findGiftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.properties && item.properties[GIFT_PROPERTY]) return item;
    }
    return null;
  }

  function setGiftStatus(root, text, state) {
    var status = root.querySelector('[data-free-gift-status]');
    if (!status) return;
    status.textContent = text;
    status.hidden = !text;
    if (state) {
      status.setAttribute('data-state', state);
    } else {
      status.removeAttribute('data-state');
    }
  }

  function markSelectedGift(root, variantId) {
    root.querySelectorAll('[data-free-gift-option]').forEach(function (btn) {
      var isMatch = btn.getAttribute('data-variant-id') === String(variantId);
      btn.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
    });
  }

  function initFreeGiftPickers() {
    document.querySelectorAll('[data-free-gift]').forEach(function (root) {
      if (root.hasAttribute('data-gift-bound')) return;
      root.setAttribute('data-gift-bound', '');

      // Reflect any gift already in the cart, if theme.js already knows it.
      if (window.Modera.cartState) {
        var existing = findGiftLine(window.Modera.cartState);
        if (existing) markSelectedGift(root, existing.variant_id);
      }

      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-free-gift-option]');
        if (!btn || !root.contains(btn)) return;
        e.preventDefault();

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        setGiftStatus(root, window.Modera.strings.freeGiftAdding, null);

        fetch(window.Modera.routes.cart + '.js', {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var existing = findGiftLine(cart);
            if (existing && String(existing.variant_id) !== variantId) {
              return fetch(window.Modera.routes.cartChange, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: existing.key, quantity: 0 })
              });
            }
            return null;
          })
          .then(function () {
            return fetch(window.Modera.routes.cartAdd, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [
                  {
                    id: variantId,
                    quantity: 1,
                    properties: { '_free_gift': 'yes' }
                  }
                ]
              })
            });
          })
          .then(function (r) { return r.json(); })
          .then(function () {
            markSelectedGift(root, variantId);
            setGiftStatus(root, window.Modera.strings.freeGiftAdded, 'added');
            document.querySelectorAll('[data-free-gift]').forEach(function (otherRoot) {
              if (otherRoot !== root) markSelectedGift(otherRoot, variantId);
            });
            return refreshCart(false);
          })
          .catch(function () {
            setGiftStatus(root, window.Modera.strings.freeGiftError, null);
          });
      });
    });
  }

  initFreeGiftPickers();
  document.addEventListener('modera:cart-refreshed', initFreeGiftPickers);

  /* ---------------- quantity steppers ---------------- */

  on('[data-qty]', 'click', function (e, el) {
    e.preventDefault();
    var wrap = el.closest('.qty');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var value = parseInt(input.value, 10) || min;
    value += el.getAttribute('data-qty') === 'up' ? 1 : -1;
    input.value = Math.max(min, value);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- product gallery ---------------- */

  on('[data-thumb]', 'click', function (e, el) {
    e.preventDefault();
    var index = el.getAttribute('data-thumb');
    var gallery = el.closest('[data-gallery]');
    if (!gallery) return;
    gallery.querySelectorAll('[data-slide]').forEach(function (slide) {
      if (slide.getAttribute('data-slide') === index) {
        slide.setAttribute('data-active', '');
      } else {
        slide.removeAttribute('data-active');
      }
    });
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.setAttribute('aria-current', thumb === el ? 'true' : 'false');
    });
  });

  /* ---------------- variant selection ---------------- */

  on('[data-variant-select]', 'change', function (e, select) {
    var form = select.closest('[data-product-form]');
    if (!form) return;
    var option = select.options[select.selectedIndex];
    var idInput = form.querySelector('[name="id"]');
    if (idInput) idInput.value = select.value;

    var price = form.querySelector('[data-variant-price]');
    if (price && option.dataset.price) price.textContent = formatMoney(option.dataset.price);

    var compare = form.querySelector('[data-variant-compare]');
    if (compare) {
      if (option.dataset.compare && Number(option.dataset.compare) > Number(option.dataset.price)) {
        compare.textContent = formatMoney(option.dataset.compare);
        compare.hidden = false;
      } else {
        compare.hidden = true;
      }
    }

    var submit = form.querySelector('[data-add-button]');
    if (submit) {
      var available = option.dataset.available === 'true';
      submit.disabled = !available;
      submit.textContent = available
        ? submit.getAttribute('data-label-default')
        : submit.getAttribute('data-label-soldout');
    }
  });

  /* ---------------- sticky buy bar ---------------- */

  var stickyBar = document.querySelector('.sticky-buy');
  var buyAnchor = document.querySelector('[data-buy-anchor]');

  if (stickyBar && buyAnchor && 'IntersectionObserver' in window) {
    body.classList.add('has-sticky-buy');
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stickyBar.removeAttribute('data-show');
          } else {
            stickyBar.setAttribute('data-show', '');
          }
        });
      },
      { rootMargin: '0px 0px -60% 0px' }
    ).observe(buyAnchor);
  }

  on('[data-sticky-add]', 'click', function (e) {
    e.preventDefault();
    var form = document.querySelector('[data-product-form] form');
    if (!form) return;
    // Bubbles up to the delegated submit handler above.
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  });

  /* ---------------- sort chips ---------------- */

  on('[data-sort]', 'click', function (e, el) {
    e.preventDefault();
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', el.getAttribute('data-sort'));
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------------- smooth anchor scroll ----------------
     CSS scroll-behavior was removed during design review; anchors are
     tweened here instead so in-page jumps land reliably. */

  on('[data-scroll-to]', 'click', function (e, el) {
    var id = el.getAttribute('data-scroll-to');
    var target = document.getElementById(id);
    if (!target) return; // Not on this page — let the href navigate.
    e.preventDefault();
    closeDrawer();

    var to = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - 80);
    var from = window.pageYOffset;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo(0, to);
      return;
    }
    var start = performance.now();
    (function step(now) {
      var k = Math.min(1, (now - start) / 520);
      var eased = 1 - Math.pow(1 - k, 3);
      window.scrollTo(0, from + (to - from) * eased);
      if (k < 1) requestAnimationFrame(step);
    })(start);
  });
})();
